import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { HOTLINE_MODAL_TITLE } from '@/components/modals/hotline-modal';
import styles from './hotline-modal.module.scss';

export const HotlineModalContent = () => (
  <div className={styles['modal-content']}>
    <Text align="center">{HOTLINE_MODAL_TITLE}</Text>
    <TextCTA as="a" href="tel:+494063601718">
      040 6360 1718
    </TextCTA>
    <Text align="center" bold className={styles.text} size="xs">
      Montags bis freitags von 8:00 bis 18:00 Uhr.
    </Text>
  </div>
);
